import * as React from "react";

function SvgTasksFilled(props) {
  return <svg viewBox="0 0 38 42" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M33.583 4.25h-8.716C24.007 1.827 21.717.083 19 .083s-5.006 1.744-5.867 4.167H4.417A4.166 4.166 0 00.25 8.417v29.166a4.166 4.166 0 004.167 4.167h29.166a4.166 4.166 0 004.167-4.167V8.417a4.166 4.166 0 00-4.167-4.167zM12.14 19.444l4.777 4.777 8.943-8.944 2.946 2.946-11.89 11.89-7.722-7.723 2.946-2.946zM19 4.25a2.084 2.084 0 11-.002 4.168A2.084 2.084 0 0119 4.25z" /></svg>;
}

export default SvgTasksFilled;